export default {
	setOurClients(state, our_clients) {
		state.our_clients = our_clients
	},
}
